import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from '@trevor/ui-components';
import flex from '../css/module/flex.css';
import ModalSqlEditor from '../components/modals/ModalSqlEditor';
import ModalSelect from '../components/modals/ModalSelect';
import PopupModal from '../components/modals/PopupModal';
import ErrorBoundary from '../components/ErrorBoundary';
import {
  modalHidden as modalHiddenAction,
  modalInteraction,
  modalSaveClicked,
} from '../actions';

export const MODAL_BUTTON_SELECTOR = 'modalDoneButton';

class Modal extends Component {
  render() {
    const {
      current,
      columns,
      existingLayer,
      templateToReplace,
      onModalInteraction,
      saveClicked,
      modals,
      usedAliases,
      fullScreen,
      modalHidden,
      existingViews,
      tables,
      dbType,
      isFreePlan,
      isLite,
      isBusiness,
      canRefreshEvery5Minutes,
    } = this.props;
    let content;
    let title;
    let subTitle;
    let state;
    let includeSaveButton = true;
    let readyForSave = false;

    if (current) {
      const modalType = current.modalType();
      state = current.reducer(modals);
      content = React.createElement(current, {
        state,
        userInteraction: onModalInteraction(modalType),
        isFreePlan,
        columns,
        usedAliases,
        tables,
        existingViews,
        dbType,
        isLite,
        isBusiness,
        canRefreshEvery5Minutes,
      });
      title = current.title(state);
      if (current.subTitle) {
        subTitle = current.subTitle(state);
      }
      if (current.includeSaveButton) {
        includeSaveButton = current.includeSaveButton();
      }
      readyForSave = !state ? false : state.readyForSave; // reducer may not define this, in which case readyForSave is always false
    }

    const saveButton = !includeSaveButton ? null : (
      <Button
        onClick={saveClicked(current, state, existingLayer, templateToReplace)}
        disabled={!readyForSave}
      >
        Done
      </Button>
    );

    if (fullScreen) {
      return (
        <div className="full-screen-modal">
          <nav className="navbar navbar-default navbar-fixed-top navbar-blue">
            <div
              className="container-fluid text-align-center"
              style={{ marginTop: '0px' }}
            >
              <div className="navbar-header full-width">
                <h5 className="display-inline-block">{title}</h5>
                <div className={flex.inline} style={{ fontWeight: 'normal' }}>
                  <Button
                    variant="secondary"
                    type="button"
                    onClick={modalHidden}
                  >
                    {includeSaveButton ? 'Cancel' : 'Close'}
                  </Button>
                  {saveButton}
                </div>
              </div>
            </div>
          </nav>
          <div className="below-navbar">
            <ErrorBoundary key={!!current}>{content}</ErrorBoundary>
          </div>
        </div>
      );
    }
    return (
      <PopupModal
        isSelectModal={current === ModalSelect}
        title={title}
        subTitle={subTitle}
        saveButton={saveButton}
        modalHidden={modalHidden}
        wide={[ModalSqlEditor, ModalSelect].includes(current)}
      >
        <ErrorBoundary key={!!current}>{content}</ErrorBoundary>
      </PopupModal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    modals: state.modals,
    current: state.modals.meta.current,
    columns: state.modals.meta.columns,
    fullScreen: state.modals.meta.fullScreen,
    existingLayer: state.modals.meta.existingLayer,
    templateToReplace: state.modals.meta.templateToReplace,
    usedAliases: state.layers.usedAliases,
    existingViews: state.views.allViews,
    tables: state.datasource.tables,
    dbType: state.datasource.dbType,
    isFreePlan: state.datasource.maxSteps < 999,
    isLite: state.datasource.isLite,
    isBusiness: state.datasource.isProPlus,
    canRefreshEvery5Minutes: !state.datasource.canRefreshDbFiveMinutesDisabled,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    modalHidden: () => {
      dispatch(modalHiddenAction());
    },
    saveClicked:
      (currentModal, state, existingLayer, templateToReplace) => () => {
        dispatch(
          modalSaveClicked(
            currentModal,
            state,
            existingLayer,
            templateToReplace,
          ),
        );
      },
    onModalInteraction: (modalType) => (props) => (e) => {
      if (e && e.preventDefault) {
        e.preventDefault();
      }
      dispatch(modalInteraction(modalType, props));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
